export const BANKACCOUNT_LOADING = 'BANKACCOUNT_LOADING';
export const BANKACCOUNT_FULFILLED = 'BANKACCOUNT_FULFILLED';
export const BANKACCOUNTS_FULFILLED = 'BANKACCOUNTS_FULFILLED';
